import type { LucideIcon } from 'lucide-react'

type ProfessionItemProps = {
  onClick: () => void
  Icon?: LucideIcon
  label: string
}

const ProfessionItem = ({ onClick, Icon, label }: ProfessionItemProps) => {
  return (
    <div className="group flex w-full cursor-pointer items-center justify-between rounded-lg pr-4" onClick={onClick}>
      <div className="flex items-center gap-3">
        <div className="flex size-[50px] items-center justify-center rounded-sm bg-secondary/10">
          {Icon && <Icon className="size-8" />}
        </div>
        <span className="text-sm font-medium">{label}</span>
      </div>
      <div className="opacity-0 transition-opacity group-hover:opacity-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="size-5"
        >
          <path d="m9 18 6-6-6-6" />
        </svg>
      </div>
    </div>
  )
}

export default ProfessionItem
